import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/video-settings.vue
var o = {
	name: "DtIconVideoSettings",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--video-settings"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Video Settings",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M2 3.117a.5.5 0 0 0-.5.5.5.5 0 0 1-1 0 1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5v1.066L10.723 3.2a.5.5 0 0 1 .777.416v4a.5.5 0 0 1-.777.416L8.5 6.551v1.066a1.5 1.5 0 0 1-1.5 1.5.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H2Zm6.902 2.5L10.5 6.683V4.55L8.902 5.617Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M2.236 4.624a1.01 1.01 0 0 1 1.01-1.009h.419a1.008 1.008 0 0 1 1.008 1.012l.004.004a.014.014 0 0 0 .005.001l.003-.001A1.008 1.008 0 0 1 6.063 5l.21.363a1.009 1.009 0 0 1-.373 1.38l-.001.006v.005l.004.003c.483.278.648.895.37 1.378l-.21.363a1.009 1.009 0 0 1-1.38.367l-.006.002a.015.015 0 0 0-.004.003v.004a1.01 1.01 0 0 1-1.009 1.009h-.419A1.01 1.01 0 0 1 2.236 8.87l-.004-.004a.015.015 0 0 0-.005-.002l-.004.002c-.483.278-1.1.113-1.378-.37l-.21-.363a1.008 1.008 0 0 1 .372-1.38l.001-.004v-.005l-.004-.002a1.008 1.008 0 0 1-.369-1.378l.21-.363a1.009 1.009 0 0 1 1.381-.367l.006-.002a.015.015 0 0 0 .004-.003v-.005ZM5.9 6.754ZM3.237 4.621v.003a1.01 1.01 0 0 1-1.514.874l-.003-.001h-.003a.01.01 0 0 0-.004.001l-.002.003-.21.363v.007a.01.01 0 0 0 .001.003l.002.002a1.008 1.008 0 0 1 0 1.746c-.002 0-.002.001-.002.002l-.002.003a.01.01 0 0 0 0 .003l.001.003.21.363A.008.008 0 0 0 1.713 8h.003a.01.01 0 0 0 .004 0h.003a1.009 1.009 0 0 1 1.513.873v.004l.003.003a.01.01 0 0 0 .003.002h.426l.002-.002a.01.01 0 0 0 .002-.003v-.003a1.008 1.008 0 0 1 1.516-.872h.004A.01.01 0 0 0 5.195 8l.002-.002.21-.363a.008.008 0 0 0 0-.003v-.004a.01.01 0 0 0-.001-.003l-.003-.002a1.009 1.009 0 0 1 0-1.748l.003-.002.001-.004a.01.01 0 0 0 0-.003v-.003l-.21-.363-.002-.003a.01.01 0 0 0-.003-.001.01.01 0 0 0-.004 0h-.003a1.008 1.008 0 0 1-1.512-.873V4.62l-.003-.002a.01.01 0 0 0-.002-.002h-.426s-.002 0-.003.002a.01.01 0 0 0-.002.003Z",
			fill: "currentColor"
		}, null, -1),
		r("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M2.454 6.748a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
			fill: "currentColor"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=video-settings.js.map